var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"union-chapter"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":16}},[_c('div',{staticClass:"summary-text",domProps:{"innerHTML":_vm._s(_vm.unionSketch)}})]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',[_c('img',{attrs:{"src":_vm.summaryPic,"width":"100%","alt":""}})])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3e1a4bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/views/overview/unionSummary.vue
// module id = null
// module chunks = 